// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services --------------------
import { buscarTodasCompatibilidadesService } from "../../../services/buscarTodasCompatibilidadesService";

export const useTodasCompatibilidades = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const todasCompatibilidades = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const dados = await buscarTodasCompatibilidadesService();

      console.log(dados);

      if (dados) {
        setSuccess("Busca realizada com sucesso!");
      } else {
        setError(
          "Houve um erro ao realizar a busca, por favor tente novamente!"
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    todasCompatibilidades,
    isLoading,
    error,
    success,
    resetError,
    resetSuccess,
  };
};
